module.exports = __webpack_public_path__ + "static/clients-icon-0f0003d784f5983740c2dd24f142f4d7.png";